
import { defineComponent } from 'vue'

// note information
interface NoteInfo {
  title: string,
  url: string,
  text: string
}

export default defineComponent({
  data () {
    return {
      notes: [
        {
          title: '超伝導GL理論の微視的な導出',
          url: '/notes/GL_microscopic_derivation_real.pdf',
          text: 'Ginzburg–Landau (GL)方程式を微視的なハミルトニアンに基づいて導出する方法に関するノート。昔から知られているはずなのだが意外と文献が少ないので自分なりにまとめてみた(自分用の備忘録のため記述がやや雑かもしれない)。このノートの短縮版は<a href="https://arxiv.org/abs/2506.22297" target="_blank">2506.22297</a>のAppendix Bにも掲載した。'
        },
        {
          title: '感受率の結晶対称性について',
          url: '/notes/susceptibility_symmetry.pdf',
          text: '実空間と波数空間の間のフーリエ変換には、副格子の内部座標を含む or 含まないの2種類のconventionがあることが知られているが、このconventionの違いに注意しないと感受率が系の結晶対称性を破ってしまうことがある、ということを理解するためのノート。グリーン関数法でスピン感受率を計算するコードを組んでいるときにこの問題に遭遇しかなり時間を溶かしたので、今後同じ犠牲者(?)を減らすことを願って公開する。このノートの短縮版は<a href="https://arxiv.org/abs/2308.14227" target="_blank">2308.14227</a>のAppendix Aにも掲載した。(2024.12.13追記：結論に影響はないが、フーリエ変換の係数に誤りがあったので訂正した。)'
        },
        {
          title: '対称性と群の表現論に基づく超伝導ギャップ・ノード構造の分類理論',
          url: '/notes/gap_classification_rep.pdf',
          text: '<a href="https://www.ms.u-tokyo.ac.jp/~yasuyuki/crest2022.htm" target="_blank">CRESTチュートリアル・ワークショップ「物質のトポロジカル相の理論的探究」</a>で講演を行った際のノート。作るのにとても時間がかかった。講演が終わった後も時々修正したりしているが、直せていない箇所もある(2.5.1節の記述などは若干間違っている気がする)。'
        },
        {
          title: '一般的なBogoliubov変換とギャップ方程式',
          url: '/notes/Bogoliubov-trans_gap-eq.pdf',
          text: 'よくある超伝導ギャップ方程式の導出(ユニタリ超伝導のみ)。後半は、(結晶の等方性は仮定するが)スピン空間の等方性を仮定しない場合に線形化ギャップ方程式を解く方法を示した。等方的なスピン空間を仮定する場合(ほとんどの教科書ではこれを仮定しているように思う)にはスピン一重項超伝導とスピン三重項超伝導で導出の仕方に違いはないが、仮定しない場合にはスピン三重項超伝導についての定式化が若干異なり、ベクトル球面調和関数の知識を要する。このノートの一部は<a href="https://arxiv.org/abs/2004.08086" target="_blank">2004.08086</a>のAppendixに掲載した。'
        },
        {
          title: 'ベクトル球面調和関数',
          url: '/notes/vector_spherical_harmonics.pdf',
          text: 'ベクトル球面調和関数の定義とちょっとした例。上のノートを作る際に参照した。'
        }
      ] as NoteInfo[]
    }
  }
})
